<!-- Spinner (no specific progress) -->
<div
	*ngIf="isSpinner"
	class="spinner-border spinner-border-sm"
	role="status"
	aria-hidden="true"
></div>

<!-- Progress Wheel (Circular) with pulsate animation -->
<svg
	*ngIf="isProgressWheel"
	class="progress-wheel"
	width="35"
	height="35"
	viewBox="0 0 50 50"
>
	<!-- Background circle (inner) -->
	<circle
		cx="25"
		cy="25"
		r="16"
		fill="none"
		[attr.stroke]="strokeColorLight"
		stroke-width="3"
		stroke-opacity="0.15"
		class="progress-circle-bg"
	/>
	<!-- Progress circle (inner) with rotation via group -->
	<g transform="rotate(-90 25 25)">
		<circle
			cx="25"
			cy="25"
			r="16"
			fill="none"
			[attr.stroke]="strokeColor"
			stroke-width="4"
			[attr.stroke-dasharray]="strokeDasharray"
			class="progress-circle"
		/>
	</g>
	<!-- Progress percentage text -->
	<text
		x="25"
		y="25"
		text-anchor="middle"
		dominant-baseline="central"
		[attr.fill]="strokeColor"
		font-size="12"
		font-weight="bold"
		class="progress-text"
	>
		{{ progress }}
	</text>
</svg>
